module.exports = __webpack_public_path__ + "static/media/Suspension_parts_white.63b0abb8.webp";